import { useIsDark } from '@/viewmodel/shared/theme/hooks/useIsDark';

interface ThemeView {
  readonly isDark: boolean;
}

export function useThemeViewModel(): ThemeView {
  return { isDark: useIsDark() };
}
